import { useRequestMutation } from "hooks/useRequest";
import { Chat, Reference } from "models/AiResearch";
import { convertKeysDeepToLowerCamel } from "utils/helper/convertNamingConvention";

// 過去のチャット表示用
export const useHistoryChat = ({
  setResult
}: {
  setResult: React.Dispatch<React.SetStateAction<Chat>>;
}) => {
  const { trigger } = useRequestMutation<
    {
      talkId: string;
      talkHistorys: {
        question: string;
        answer: string;
        questionDate: string;
      }[];
    },
    { talkId: string }
  >("/sse/query/rag/history", "GET", {
    onSuccess: data => {
      setResult({
        talkId: data.talkId,
        history: data.talkHistorys.map(item => {
          const parsedAnswer = JSON.parse(item.answer);
          const convertedAnswer = (convertKeysDeepToLowerCamel(
            parsedAnswer
          ) as unknown) as {
            ids: {
              questionId: string;
              answerId: string;
            }[];
            message?: string[];
            citationSource: Reference[];
            questionAssistance?: string[];
            relatedQuestions?: { questions: string[] }[];
            error?: {
              systemMessage: string;
              userMessage: string;
            }[];
          };
          return {
            question: item.question,
            answer: convertedAnswer.error
              ? convertedAnswer.error?.[0].userMessage || ""
              : convertedAnswer.message?.join("") || "",
            reference: convertedAnswer.citationSource,
            questionAt: item.questionDate,
            questionOptimization: convertedAnswer.questionAssistance?.[0] || "",
            relatedQuestions:
              convertedAnswer.relatedQuestions?.slice(-1)[0].questions || [],
            ids: convertedAnswer.ids[0],
            isError: convertedAnswer.error !== undefined,
            sseStatus: "closed"
          };
        })
      });
    }
  });

  return { fetchHistoryChat: trigger };
};
